const marketplace = {
  title: "Add-ons store",
  subtitle: "Boost your business with tools and partnerships",
  sections: {
    myTools: "My tools",
    bestSellers: "Best sellers",
    partners: "Partnerships",
  },
  card: {
    installed: "Active",
  },
  detail: {
    back: "Back",
    loading: "Loading add-on...",
    loadError: "The add-on could not be loaded",
    reviews: "Reviews",
    availableInApp: "This tool is available from the Domun app.",
    acquired: "Acquired",
    free: "Free",
    open: "Open",
    getFree: "Get for free",
    acquire: "Get",
    freeSuccess: "Add-on activated successfully!",
    acquireError: "The add-on could not be acquired",
    openAlliance: "Go to partnership",
  },
};

export default marketplace;
